/* unplugin-vue-components disabled */import { render } from "./formTmpl.vue?vue&type=template&id=1662d32c&scoped=true"
import script from "./formTmpl.vue?vue&type=script&lang=js"
export * from "./formTmpl.vue?vue&type=script&lang=js"

import "./formTmpl.vue?vue&type=style&index=0&id=1662d32c&scoped=true&lang=css"

import exportComponent from "/Users/huangzhichao/Code/beyoung/weitu_land_page_h5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1662d32c"]])

export default __exports__